import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["id", "disabled", "placeholder", "required", "max", "min"];
import { ref, watch } from "vue";
import log from "../../services/Logger";
export default /*@__PURE__*/ _defineComponent({
    __name: 'FieldControlNumber',
    props: {
        form: {},
        validation: {},
        field: {},
        fieldId: {},
        data: {}
    },
    emits: [
        'change',
        'focus',
        'blur'
    ],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const props = __props;
        const model = ref(createModel()); // we need to allow string values as well because of the browser sometimes the value will be a string
        const fieldOptions = props.field.options || {};
        function createModel() {
            if (props.data === undefined || props.data === null) {
                return undefined;
            }
            if (typeof props.data === 'number') {
                return props.data;
            }
            return parseFloat("" + props.data);
        }
        // changes from the outside
        watch(() => props.data, () => model.value = createModel());
        // changes from the inside
        function onChange() {
            const value = (model.value === undefined || model.value === "" || isNaN(model.value)) ? null : model.value;
            log('FieldControlNumber@change', props.field.name, value);
            emit('change', value);
        }
        function onFocus() {
            emit('focus');
        }
        function onBlur() {
            emit('blur');
        }
        return (_ctx, _cache) => {
            return _withDirectives((_openBlock(), _createElementBlock("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((model).value = $event)),
                onInput: onChange,
                onFocus: onFocus,
                onBlur: onBlur,
                type: "number",
                step: "any",
                id: __props.fieldId,
                disabled: _unref(fieldOptions).disabled ?? undefined,
                placeholder: _unref(fieldOptions).placeholder ?? undefined,
                required: _unref(fieldOptions).required ?? undefined,
                max: _unref(fieldOptions).max ?? undefined,
                min: _unref(fieldOptions).min ?? undefined,
                class: "form__control"
            }, null, 40, _hoisted_1)), [
                [
                    _vModelText,
                    model.value,
                    void 0,
                    { number: true }
                ]
            ]);
        };
    }
});
